import React from "react";
import { Controller, useFormContext } from "react-hook-form";

const ModifiedCheckbox = ({ service, setServiceChange }) => {
  const { control } = useFormContext();
  const serviceId = parseInt(service.term_id);

  return (
    <Controller
      name={`services.${serviceId}`}
      control={control}
      defaultValue={false}
      render={({ field }) => (
        <div className="hover:cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md bg-gray-50 border-r border-b border-gray-200 mb-2">
          <label className="hover:cursor-pointer flex items-center mb-0" htmlFor={`services.${serviceId}`}>
            <input
              type="checkbox"
              onChange={e => {
                console.log(`Checkbox ${serviceId} changed:`, e.target.checked);
                field.onChange(e);
                setServiceChange(true);
              }}
              checked={field.value}
              className="ml-0 mr-2 hover:cursor-pointer"
              id={`services.${serviceId}`}
            />
            {service.name}
          </label>
        </div>
      )}
    />
  );
};

export default ModifiedCheckbox;
